export default {
  reviewCompleteHeader: '审核并完成',
  participants: '参与者',
  enterParticipantInfoText: '请输入所需详细信息以继续结账。',
  purchaser: '购买者',
  firstName: '名字',
  lastName: '姓氏',
  email: '电子邮箱',
  optionalEmail: '电子邮箱：（选填）',
  'phone:': '电话',
  participantFieldPlaceholder: '添加新参与者或选择现有参与者',
  reservationSummary: '预订摘要',
  editParticipantsDetails: '编辑参与者详情',
  participantDetails: '详情',
  duplicatePurchaserText: '与购买者相同',
  phone: '电话',
  addParticipant: '额外{{tierLabel}}',
  participant: '参与者',
  removeParticipant: '移除',
  experienceCheckoutCompleted: '体验结账完成',
  experienceCartCheckout: '体验购物车结账',
  experienceLimitReached: '抱歉，此体验已达到最大参与者数量',
  payment: '支付',
  duration: '时长',
  discountCode: '优惠码',
  removeCode: '移除优惠码',
  invalidCodeValidation: '无效的优惠码',
  networkErrorDiscountCode: '我们这边出现了问题',
  onlyOneCouponCodeAllowed: '只能使用一个优惠码',
  creditCodeHasAlreadyBeenApplied: '优惠码已应用',
  discount: '折扣',
  promo: '促销',
  promoCode: '促销码',
  apply: '应用',
  total: '总计',
  subTotal: '小计',
  includes: '包含',
  and: '和',
  addHostNotes: '为主办方添加备注',
  brandAggreementText: '我同意，或我证明我代表参与者同意以下条款和条件',
  termsAggreementValidation: '请同意条款',
  firstNameValidation: '名字为必填项',
  lastNameValidation: '姓氏为必填项',
  emailValidation: {
    emailRequiredText: '电子邮箱为必填项',
    invalidEmail: '无效的电子邮箱地址',
    not_specified: '不正确的电子邮箱地址',
  },
  phoneValidation: {
    'Invalid Phone Number': '无效的电话号码',
    not_specified: '无效',
    phoneRequiredText: '电话号码为必填项',
  },
  participantFirstNameValidation: '参与者名字为必填项',
  participantLastNameValidation: '参与者姓氏为必填项',
  complete: '完成',
  '404Message': '未找到',
  waiting: '等待中...',
  complimentary: '免费',
  confirmationHeader: '您的体验已预订成功！',
  confirmationText: '确认邮件已发送至{{email}}，包含更多详情',
  viewAll: '查看所有体验',
  paymentMethod: '支付方式',
  creditCard: '信用卡',
  roomCharge: '房费',
  memberCharge: '会员费',
  roomOrReservationNumber: '房间号或确认号',
  roomNumber: '房间号',
  roomNumberLegacy: '房间号/确认码',
  memberNumber: '会员号',
  kicc: '轻松支付',
  chargeValidation: '房间号和姓氏为必填项',
  memberNumberValidation: '会员号为必填项',
  invalidRoomNumber: '房间号无效',
  invalidRoomNumberLegacy: '房间号或确认码无效',
  invalidMemberNumber: '会员号无效',
  invalidPhoneNumber: '电话号码无效',
  requiredPhoneNumber: '电话号码为必填项',
  guestNameIsRequired: '客人姓名为必填项',
  roomNumberIsRequired: '房间号为必填项',
  roomNumberIsRequiredLegacy: '房间号或确认码为必填项',
  roomOrReservationNumberIsRequired: '房间号或确认号为必填项',
  cardNumberIncomplete: '卡号不完整',
  lastNameValidationError: '姓氏为必填项',
  isReqd: '为必填项',
  reservationCode: '预订/确认号',
  nonHotelGuest: '非酒店客人',
  onPropertyGuest: '在店客人',
  preArrivalGuest: '预到店客人',
  cardNumber: '卡号',
  pmsValidationErrorMessage: '姓氏、房间号或确认号无效',
  pmsDateValidationErrorMessage: '抱歉！体验日期不在您的入住和离店日期之间。',
  fullName: '全名',
  checkout: '结账',
  editParticipants: '编辑参与者',
  private: '私人',
  browseAllExperieces: '浏览所有体验',
  payWithCreditCard: '使用信用卡支付',
  payWithRoomCharge: '使用房费支付',
  payWithMemberCharge: '使用会员费支付',
  payWith: '支付方式',
  bookBulkErrorByCard: '确认预订时出现问题。您的卡未被收费。',
  bookBulkErrorByRoomCharge: '姓氏和房间号无效。',
  bookBulkErrorByMemberCharge: '姓氏和会员号无效。',
  reviewCancellation: '审核取消',
  selectAReservationToCancel: '选择要取消的预订',
  confirmCancellation: '确认取消',
  cancellable: '可取消',
  cancelled: '已取消',
  deadlinePassed: '截止日期已过',
  noCancellations: '不可取消',
  reviewReschedule: '您的预订',
  selectAReservationToReschedule: '选择要重新安排的预订',
  confirmReservation: '确认预订',
  confirm: '确认',
  selectADateAndTime: '选择日期和时间',
  noOtherSessionsAvailableForThisExperience: '此体验没有其他可用时段。',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    '此预订无法重新安排。请发送邮件至{{brandEmail}}',
  thisReservationCannotBeRescheduled: '此预订无法重新安排',
  noTimesAvailable: '无可用时间',
  noBookingsAvailable: '无可用预订',
  youPaid: '您支付了',
  refund: '退款',
  yourRefund: '您的退款',
  yourRefundWillBeProcessedToTheOriginalPayment: '您的退款将退回至原支付方式。',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    '此预订无法取消。请发送邮件至{{brandEmail}}',
  reservationCancelled: '预订已取消',
  thisReservationCannotBeCancelled: '此预订无法取消',
  thisReservationHasAlreadyBeenCancelled: '此预订已被取消',
  theHotel: '酒店',
  cancelling: '取消中',
  somethingWentWrong: '出现错误',
  previouslyRefunded: '已退款',
  remainingBalance: '剩余余额',
  notEnoughPoints: '积分不足',
  notEnoughPointsDescription: '您没有足够的凯悦天地积分完成此购买。',
  currentPointsBalance: '当前积分余额：{{count, number}}',
  points: '积分',
  pointsWithCount_one: '{{count, number}}积分',
  pointsWithCount_other: '{{count, number}}积分',
  payWithHyattPoints: '使用凯悦天地积分支付',
  pleaseSignIn: '请登录',
  worldOfHyattPoints: '凯悦天地积分',
  bookBulkErrorByNotEnoughSeats: '该时段座位不足。请尝试其他时段。',
  phoneNumber: '电话号码',
  requestToBookConfirmationText: '确认邮件已发送至{{email}}',
  reservationRescheduled: '预订已重新安排',
  yourReservationWasRescheduledTo: '您的预订已重新安排至',
  viewExperiences: '查看体验',
  joinBook: '加入并预订',
  signInBook: '登录并预订',
  signAndJoin: '登录或加入以预订',
  signAndJoinDescription:
    'World of Hyatt FIND体验仅对World of Hyatt会员开放。登录或加入以预订并赚取积分。不想加入？您仍然可以通过删除World of Hyatt体验从购物车预订非独家体验。',
  promoOrFind: '促销码或 FIND 积分代码',
  hyattTermsAndConditions: '条款与条件',
  hyattTermsAndConditionsAgreement:
    '确认此预订即表示我接受取消政策。我还已阅读并知晓根据以下规定使用我的个人信息：',
  hyattTermsAndConditionsLink: '凯悦隐私政策',
  hyattWaiverText:
    '通过购买此体验，我本人以及任何由我购买此体验而参与的个人（如有）均同意、理解并承认以下内容',
  hyattWaiverLink: '通用免责声明',
  priceDisclaimer: '包括前税费',
  curatedRecommendations: '定制推荐',
  moreExperiencesYouMightLike: '你可能喜欢的更多体验',
  similarExperiencesAvailableToBookDirectly: '类似体验可直接预订',
  experiencesAvailableAroundYourBookingDate: '预订日期附近的体验',
  confirmationEmailSent: '确认邮件已发送至{{email}}，包含更多详情。',
  youreBooked: '您已预订',
  purchaserInformation: '购买者信息',
  requiredFieldIndicator: '* 表示必填字段',
  resourceSelectionTitle: '选择您的选项',
  resourceSelectionDescription: '请为预订中的每一项选择一个选项。',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: '选择{{attributeName}}',
  resourceValueSoldOut: '{{label}}（已售罄）',
  resourceValueUnavailableWith: '{{label}}（不适用于{{picks}}）',
  resourceOptionsUnavailable: '无法加载此时段的选项，请重试。',
  resourceOptionsRetry: '重试',
  changeResourceSelections: '更改您的选择',
};
